import React, { useState } from 'react'

import { useReferralRecommendation } from '@modules/Dashboard/modules/Recommendations/modules/ReferralRecommendation/hooks/useReferralRecommendation'

import { useAffiliateReferrals } from '../Samples/hooks/useAffiliateReferrals'
import { ReferralsView } from './ReferralsView'

const LIMIT = 10

export const ReferralsContainer = () => {
  const [page, setPage] = useState(1)
  const { affiliateReferrals } = useAffiliateReferrals({
    page,
    limit: LIMIT,
  })
  const { shortLink, recommendationTitle, recommendationDescription } = useReferralRecommendation()

  return (
    <ReferralsView
      referrals={affiliateReferrals.referrals}
      totalPages={affiliateReferrals.pageResult?.totalPages}
      total={affiliateReferrals.pageResult?.elementsTotal}
      limit={LIMIT}
      shortLink={shortLink}
      title={recommendationTitle}
      description={recommendationDescription}
      page={page}
      setPage={setPage}
    />
  )
}
